module.exports = __webpack_public_path__ + "img/f-2-2.3e0ae84b.png";